/* eslint-disable react/prop-types */
import React from "react";
import Rule from "components/Homeowner/Dashboard/QueryBuilder/Rule";

export default class RuleGroup extends React.Component {

    static get defaultProps() {
        return {
            id: null,
            parentId: null,
            rules: [],
            combinator: "and",
            schema: {},
            simpleMode: false,
        };
    }

    constructor(props) {
        super(props);
        this.hasParentGroup = this.hasParentGroup.bind(this);
        this.onCombinatorChange = this.onCombinatorChange.bind(this);
        this.addRule = this.addRule.bind(this);
        this.addGroup = this.addGroup.bind(this);
        this.removeGroup = this.removeGroup.bind(this);
    }

    hasParentGroup() {
        return this.props.parentId;
    }

    onCombinatorChange(value) {
        const { onPropChange } = this.props.schema;

        onPropChange("combinator", value, this.props.id);
    }

    addRule(event) {
        event.preventDefault();
        event.stopPropagation();

        const { createRule, onRuleAdd } = this.props.schema;

        const newRule = createRule();
        onRuleAdd(newRule, this.props.id);
    }

    addGroup(event) {
        event.preventDefault();
        event.stopPropagation();

        const { createRuleGroup, onGroupAdd } = this.props.schema;
        const newGroup = createRuleGroup();
        onGroupAdd(newGroup, this.props.id);
    }

    removeGroup(event) {
        event.preventDefault();
        event.stopPropagation();

        this.props.schema.onGroupRemove(this.props.id, this.props.parentId);
    }

    render() {
        const { id, combinator, rules, translations, schema: { combinators, controls, onRuleRemove, isRuleGroup, getLevel, classNames, fields }, activeTemplate, simpleMode } = this.props;
        const level = getLevel(id);

        return (
            <div className={`ruleGroup ${classNames.ruleGroup}`}>
                {
                    controls.combinatorSelector ?
                        React.createElement(controls.combinatorSelector,
                            {
                                options: combinators,
                                value: combinator,
                                title: translations.combinators.title,
                                className: `ruleGroup-combinators ${classNames.combinators}`,
                                handleOnChange: this.onCombinatorChange,
                                rules: rules,
                                level: level
                            }
                        ) : null
                }
                {
                    React.createElement(controls.addRuleAction,
                        {
                            label: translations.addRule.label,
                            title: translations.addRule.title,
                            className: `ruleGroup-addRule ${classNames.addRule}`,
                            handleOnClick: this.addRule,
                            rules: rules,
                            level: level
                        }
                    )
                }
                {
                    controls.addGroupAction ?
                        React.createElement(controls.addGroupAction,
                            {
                                label: translations.addGroup.label,
                                title: translations.addGroup.title,
                                className: `ruleGroup-addGroup ${classNames.addGroup}`,
                                handleOnClick: this.addGroup,
                                rules: rules,
                                level: level
                            }
                        ) : null
                }
                {
                    this.hasParentGroup() ?
                        React.createElement(controls.removeGroupAction,
                            {
                                label: translations.removeGroup.label,
                                title: translations.removeGroup.title,
                                className: `ruleGroup-remove ${classNames.removeGroup}`,
                                handleOnClick: this.removeGroup,
                                rules: rules,
                                level: level
                            }
                        ) : null
                }
                {
                    rules.map(r => {
                        const field = fields.find(x => x.id === r.field);
                        return (
                            isRuleGroup(r)
                                ? <RuleGroup
                                    key={r.id}
                                    {...{ activeTemplate }}
                                    id={r.id}
                                    schema={this.props.schema}
                                    parentId={id}
                                    combinator={r.combinator}
                                    translations={translations}
                                    rules={r.rules}
                                    simpleMode={simpleMode} />
                                : <Rule
                                    key={r.id}
                                    {...{ activeTemplate }}
                                    id={r.id}
                                    field={r.field}
                                    value={r.value}
                                    operator={r.operator}
                                    schema={this.props.schema}
                                    parentId={id}
                                    translations={translations}
                                    onRuleRemove={onRuleRemove}
                                    inputType={field && field.inputType}
                                    simpleMode={simpleMode}
                                />
                        );
                    })
                }
            </div>
        );
    }
}
